import React from 'react';
import ReactDOM from 'react-dom';
import ReactHlsPlayer from 'react-hls-player';


const HlsPreview = (props) => {

    const handleClose = () => {
        props.handleClose();
    };

    return (
        <>
            <ReactHlsPlayer
                playerRef={React.createRef<HTMLVideoElement>()}
                //src="http://127.0.0.1:1935/vod-test/Subfolder1/Sub2/ae192eba-2f2e-41b5-b973-b20091b6b0c1-video.mp4/playlist.m3u8"
                src={props.data.hlsUrl}
                autoPlay={false}
                controls={true}
                width="100%"
                height="auto"
            />
        </>
    );
};

export default HlsPreview;